import { render, staticRenderFns } from "./ProviderHeaderInfo.vue?vue&type=template&id=04cc828f&scoped=true"
import script from "./ProviderHeaderInfo.vue?vue&type=script&lang=js"
export * from "./ProviderHeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./ProviderHeaderInfo.vue?vue&type=style&index=0&id=04cc828f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc828f",
  null
  
)

export default component.exports